<template>
  <div class="container">
    <div class="row text-center my-3">
      <div class="col">
        <h3>Instructions</h3>
        <div class="dropdown">
          <a
            class="dropdown-toggle"
            href="#"
            role="button"
            id="dropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >Part 2: WiFi Connection</a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <router-link class="dropdown-item" to="/instructions/assembly">Part 1: Assembly</router-link>
            <router-link class="dropdown-item" to="/instructions/installation">Part 3: Installation</router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex my-2"
      :class="{'justify-content-between':isTabNameValid(tabLists,previousTab),'justify-content-end':!isTabNameValid(tabLists,previousTab)}"
    >
      <a
        class="btn btn-primary"
        :href="'#'+previousTab"
        v-show="isTabNameValid(tabLists,previousTab)"
      >Back</a>
      <a class="btn btn-primary" :href="'#'+nextTab" v-show="isTabNameValid(tabLists,nextTab)">Next</a>
      <router-link to="/instructions/installation" replace v-show="isLastTab(tabLists,currentTab)">
        <button type="button" class="btn btn-primary">Part 3: Installation</button>
      </router-link>
    </div>
    <tabs :options="{ useUrlFragment: false }" @changed="tabChanged">
      <tab id="video" name="1.Video">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            class="embed-responsive-item"
            src="https://www.youtube.com/embed/QOzbR-ZZITE?rel=0&amp;controls=1&amp;showinfo=0"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscree
          ></iframe>
        </div>
      </tab>
      <tab id="preparation" name="2.Preparation">
        <div class="row align-items-center">
          <div class="col align-self-center">
            <div class="thumbnail">
              <img src="/workshop/brochure/steps/step10.png" class="img-fluid">
              <div
                class="caption"
              >Place the device close to the router and plug into a power outlet.
                <br>Bring your phone/tablet/computer close to the sensor.
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab id="AP" name="3.AP mode">
        <div class="row align-items-center">
          <div class="col align-self-center">
            <div class="thumbnail">
              <img src="/workshop/brochure/steps/step11.png" class="img-fluid">
              <div class="caption">
                Open the WiFi connection utility on your phone/tablet/computer.
                <br>Find and connect to the WiFi named SensorUp_IOT_XXXXXX (where XXXXXX is the MAC
                address and is specific to the sensor.)
                <br>
                <p class="font-italic">
                  NOTE: The "SensorUp_IOT_XXXXXX" network is only available while
                  the sensor is not connected to your home WiFi.
                </p>
                <b>
                  Once your phone/tablet/computer is connected to the "SensorUp_IOT_XXXXXX" network,
                  please go to next.
                </b>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab id="login" name="3.Login">
        <div class="row align-items-center">
          <div class="col-md-6">
            <img src="/workshop/brochure/steps/step12.png" class="img-fulid">
          </div>
          <div class="col-md-6 align-self-center text-left">
            <div class="thumbnail">
              <div class="caption">
                <ul>
                  <li>
                    In your web browser, go to
                    <a
                      href="http://192.168.100.1/"
                      target="_blank"
                    >http://192.168.100.1/</a>
                  </li>
                  <br>
                  <li>Account: root</li>
                  <li>
                    Password:
                    <b>sensorupgis</b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </tab>
      <tab id="stationMode" name="4.Station mode">
        <div class="row align-items-center">
          <div class="col-md-6">
            <img src="/workshop/brochure/steps/step13.png" class="img-fulid">
          </div>
          <div class="col-md-6 align-self-center text-left">
            <div class="thumbnail">
              <div class="caption">
                <ol>
                  <li>
                    Choose
                    <b>Network</b> tab
                  </li>
                  <li>
                    Choose
                    <b>Station Mode</b>
                  </li>
                  <li>Select your home WiFi from the drop-down list</li>
                  <li>Enter your home WiFi password</li>
                  <li>
                    Click
                    <b>Configure & Restart</b>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </tab>

      <tab id="checkStatus" name="5.Check Status">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <p>
              Connect back to your home WiFi.
              <br>Go to
              <a
                href="https://smartconnect.sensorup.com/"
                target="_blank"
              >smartconnect.sensorup.com</a>
              with the MAC address to see if the device is active.
            </p>
          </div>
          <div class="col-md-12 col-lg-8">
            <div class="browser-mockup with-url">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  src="https://smartconnect.sensorup.com/?rel=0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-4 align-self-center">
            <img src="/workshop/brochure/steps/step14.png" class="img-fluid">
          </div>
        </div>
      </tab>
    </tabs>
    <div
      class="d-flex my-2"
      :class="{'justify-content-between':isTabNameValid(tabLists,previousTab),'justify-content-end':!isTabNameValid(tabLists,previousTab)}"
    >
      <a
        class="btn btn-primary"
        :href="'#'+previousTab"
        v-show="isTabNameValid(tabLists,previousTab)"
      >Back</a>
      <a class="btn btn-primary" :href="'#'+nextTab" v-show="isTabNameValid(tabLists,nextTab)">Next</a>
      <router-link to="/instructions/installation" replace v-show="isLastTab(tabLists,currentTab)">
        <button type="button" class="btn btn-primary">Part 3: Installation</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      previousTab: '',
      currentTab: 'video',
      nextTab: '',
      tabLists: [
        'video',
        'preparation',
        'AP',
        'login',
        'stationMode',
        'checkStatus',
      ],
    }
  },
  methods: {
    getPreviousAndNextTabName(array, tab) {
      let i = array.indexOf(tab)
      this.previousTab = array[i == 0 ? -1 : i - 1]
      this.currentTab = array[i]
      this.nextTab = array[i == array.length - 1 ? -1 : i + 1]
    },
    isLastTab(array, tab) {
      return array.indexOf(tab) == array.length - 1
    },
    isTabNameValid(array, tab) {
      return array.indexOf(tab) >= 0
    },
    tabChanged(selectedTab) {
      this.getPreviousAndNextTabName(this.tabLists, selectedTab.tab.id)
      //   if (this.isCurrentUrlHttps()) {
      //     this.loadHttpPage()
      //   }
    },
    // reloadIFrame() {
    //   // make sure this page is loaded through http
    //   if (this.isCurrentUrlHttps()) {
    //     this.loadHttpPage()
    //   }
    //   //Since the iframe is on a different domain, you will be denied access to the iframe's contentDocument property by the same-origin policy.
    //   //document.getElementById('linkit_smart').contentWindow.location.reload();
    //   // But you can hackishly force the cross-domain iframe to reload if your code
    //   // is running on the iframe's parent page, by setting it's src attribute to itself. Like this
    //   let iframe = document.getElementById('linkit_smart')
    //   iframe.src = iframe.src
    // },
    // loadHttpPage() {
    //   window.location = window.location.href.replace('https', 'http')
    // },
    // loadHttpsPage() {
    //   window.location.href = window.location.href.replace('http', 'https')
    // },
    // isCurrentUrlHttps() {
    //   return window.location.href.indexOf('https') >= 0
    // },
  },
}
</script>
